<div
  class="buttonMenuTooltip flex h-full w-10 cursor-pointer items-center justify-center pt-1 text-white"
  (mousemove)="mouseEnterMenu()"
  (click)="onMainMenuButtonClicked()"
  #buttonToLinkPopover
>
  <pl-icon *ngIf="menuIcon" [name]="menuIcon" class="h-6 w-6"></pl-icon>
  <p *ngIf="!menuIcon && menuItemSelected" class="mb-0.5 font-sans text-inherit">{{ menuItemSelected.label }}</p>
</div>

<pl-popover
  [show]="showMenu()"
  [positionX]="PositionX.center"
  [positionY]="PositionY.above"
  (dismissed)="onPopoverDismissed()"
  (mouseLeaveParentBoundingBox)="mouseLeaveMenu()"
  [bindingElement]="buttonToLinkPopover"
>
  <div (mouseenter)="mouseEnterMenu()" (mouseleave)="mouseLeaveMenu()" class="">
    <div
      *ngFor="let menuItem of menuItems"
      class="menuTooltip-item cursor-pointer px-4 font-sans hover:bg-pl-orange-500 hover:text-white"
      [ngClass]="{ 'bg-pl-orange-500 text-white': menuItem.value === menuItemSelected?.value }"
      (click)="onMenuItemClicked(menuItem)"
    >
      {{ menuItem.label }}
    </div>
  </div>
</pl-popover>
